import { render, staticRenderFns } from "./User.Menu.Delete.vue?vue&type=template&id=45cbb0cb&scoped=true&"
import script from "./User.Menu.Delete.vue?vue&type=script&lang=js&"
export * from "./User.Menu.Delete.vue?vue&type=script&lang=js&"
import style0 from "./User.Menu.Delete.vue?vue&type=style&index=0&id=45cbb0cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cbb0cb",
  null
  
)

export default component.exports